// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qK2P","newExpiryDate":"styles_newExpiryDate__2fnOW","footer":"styles_footer__231h0"};